module.exports = __webpack_public_path__ + "img/top.ade8c901.png";